import React from 'react';
import ArrowsAnimations from 'assets/livenicons/arrows_animations.svg';
import PlanBoxWomenImg1 from 'assets/livenicons/plan_box_women_img1.png';
import PlanBoxWomenImg2 from 'assets/livenicons/plan_box_women_img2.png';

import PlanBoxMenImg1 from 'assets/livenicons/plan_box_men_img1.png';
import PlanBoxMenImg2 from 'assets/livenicons/plan_box_men_img2.png';

import { useAppSelector } from 'bootstrap/hooks';
import { QuestionIds } from 'onboarding/data/constants/QuestionIds';
import { Genders } from 'welcome/livenwelcome/LivenWelcome.hook';

import styles from './styles.module.scss';

export const PlanBox = () => {
  const { answers } = useAppSelector((state) => state.onboarding);

  const isMaleGender = answers[QuestionIds.Welcome] === Genders.Male;

  return (
    <div className={styles.personalPlan}>
      <div className={styles.planBox}>
        <div className={styles.animationArrowsActive}>
          <img src={ArrowsAnimations} alt="" />
        </div>
        <div className={`${styles.planItem} ${styles.left}`}>
          <div className={styles.label}>
            <p>Now</p>
          </div>
          <div className={styles.animationFadeRight}>
            <img
              src={isMaleGender ? PlanBoxMenImg1 : PlanBoxWomenImg1}
              alt="Illustration of a person"
            />
          </div>
          <div className={styles.infoList}>
            <div className={styles.infoItem}>
              <p className={styles.title}>Worry level</p>
              <p className={styles.description}>High</p>
            </div>
            <div className={styles.infoItem}>
              <p className={styles.title}>Focus level</p>
              <p className={styles.description}>Weak</p>
              <div className={styles.progressLine}>
                <div className={styles.activeLine}></div>
                <div className={styles.line}></div>
                <div className={styles.line}></div>
              </div>
            </div>
            <div className={styles.infoItem}>
              <p className={styles.title}>Self-esteem level</p>
              <p className={styles.description}>Low</p>
              <div className={styles.activeScaleSlider}>
                <div className={styles.circle}></div>
              </div>
            </div>
          </div>
        </div>
        <div className={`${styles.planItem} ${styles.right}`}>
          <div className={styles.label}>
            <p className={styles.active}>Your Goal</p>
          </div>
          <div className={styles.animationFadeLeft}>
            <img
              src={isMaleGender ? PlanBoxMenImg2 : PlanBoxWomenImg2}
              alt="Illustration of a person"
            />
          </div>
          <div className={styles.infoList}>
            <div className={styles.infoItem}>
              <p className={styles.title}>Worry level</p>
              <p className={styles.description}>Low</p>
            </div>
            <div className={styles.infoItem}>
              <p className={styles.title}>Focus level</p>
              <p className={styles.description}>Strong</p>
              <div className={styles.progressLine}>
                <div className={styles.activeLine}></div>
                <div className={styles.activeLine}></div>
                <div className={styles.activeLine}></div>
              </div>
            </div>
            <div className={styles.infoItem}>
              <p className={styles.title}>Self-esteem level</p>
              <p className={styles.description}>High</p>
              <div className={styles.activeScaleSlider}>
                <div className={styles.circle} style={{ left: '85%' }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
